import { parseRouteParamToEnum } from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export enum EmailType {
  Empty = 'none',
  ProactiveSearchAlert = 'proactive_search_alert',
}

export type EmailUnsubscribeRouteParams = {
  emailType?: EmailType | null;
  psaIdentifier?: string | null;
};

export type EmailUnsubscribeRouteParamsString = {
  emailType?: string;
  psaIdentifier?: string;
};

export const EmailUnsubscribe = defineRoute<
  EmailUnsubscribeRouteParams,
  EmailUnsubscribeRouteParamsString
>({
  pathname: '/email-unsubscribe',
  nlPathname: '/email-uitschrijven',
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: routeParams => {
    return {
      emailType: routeParams.emailType?.toString(),
      psaIdentifier: routeParams.psaIdentifier ?? undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      emailType:
        parseRouteParamToEnum(routeParamsString.emailType, EmailType) ||
        EmailType.Empty,
      psaIdentifier: routeParamsString.psaIdentifier || '',
    };
  },
});
